<template>
  <div class="form-body">
    <div class="row">
      <div class="form-holder">
        <div class="form" style="padding: 0px;">
          <div class="form-items">
            <!-- <span class="logo" v-html="logos"></span> -->

            <div class="row mt-5"></div>
            <!-- <h3>Welcome to Screenit</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer placerat mi fringilla mauris ullamcorper</p> -->
            <div class="container">
              <b-form
                class="register-form"
                novalidate
                style="background-color: #ffffff;padding: 20px;min-height: 500px;"
              >
                <div>
                  <div class="form-row">
                    <h1
                      class="float-left mb-0 ml-3"
                      style="all:unset; font-size:25px"
                    >
                      HI {{ form.firstName }}
                    </h1>
                  </div>
                  <br />
                  <div class="form-row nxtbtn">
                    <h3 class="float-left mb-0 ml-3">Interviewer Skills</h3>
                    <button type="button" class="btn next" @click="nextPage()">
                      Next <i class="fa fa-angle-double-right" aria-hidden="true"></i>

                    </button>
                  </div>
                  <hr />
                  <div class="form-row skills">
                    <div>
                      <div class="input-group date" id="time">
                        <select
                          name="time"
                          v-model="form.skill_desc"
                          class="sttime"
                          :class="{
                            'is-invalid': submitted && $v.form.skill_desc.$error
                          }"
                          id="time"
                          @change="F($event)"
                        >
                          <option value="">Add Skills</option>
                          <option
                            v-for="get in skills"
                            :key="get.name"
                            :value="get.name"
                            >{{ get.name }}</option
                          >
                        </select>
                        <div v-if="$v.form.skill_desc.$error">
                          <p v-if="!$v.form.skill_desc.required" class="login-alert-msg error-content">
                            *Skills is required
                          </p>
                        </div>
                        <p v-if="skillexpired">* Skill already added</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col rating">
                        <span
                          class="direct-chat-timestamp f12 "
                          style="text-align:center"
                          >Skill Rating
                          <star-rating
                            v-model="form.self_rating"
                            class="pull-right star"
                            style="width:100%"
                            :show-rating="false"
                            active-color="#5bad2b"
                            v-bind:increment="1"
                            v-bind:star-size="25"
                            rating="1"
                          ></star-rating
                        ></span>
                      </div>
                      <div class="experience"></div>
                    </div>
                    <div class="expyears">
                      <div class="form-group selectyear">
                        <div class="form-select">
                          <select
                            v-model="form.yearofexperience"
                            class="form-control"
                            @change="getTime($event)"
                            :class="{
                              'is-invalid':
                                submitted && $v.form.yearofexperience.$error
                            }"
                          >
                            <option value="" class="text" disabled
                              >Years*</option
                            >
                            <option v-for="get in 30" :key="get"
                              >{{ get }} years</option
                            >
                          </select>
                          <span class="select-icon"
                            ><i class="fa fa-chevron-down"></i
                          ></span>
                        </div>
                        <div v-if="$v.form.yearofexperience.$error">
                          <p
                            v-if="!$v.form.yearofexperience.required"
                            class="login-alert-msg error-content"
                          >
                            * Select year
                          </p>
                        </div>
                      </div>
                      <div class="form-group selectmonth">
                        <div class="form-select">
                          <select
                            v-model="form.monthofexperience"
                            class="form-control"
                            :class="{
                              'is-invalid':
                                submitted && $v.form.monthofexperience.$error
                            }"
                            >>
                            <option value="" class="text" disabled
                              >Months*</option
                            >
                            <option v-for="get in 12" :key="get"
                              >{{ get }} months</option
                            >
                          </select>
                          <span class="select-icon"
                            ><i class="fa fa-chevron-down"></i
                          ></span>
                        </div>
                        <div v-if="$v.form.monthofexperience.$error">
                          <p
                            v-if="!$v.form.monthofexperience.required"
                            class="login-alert-msg error-content"
                          >
                            * Select month
                          </p>
                        </div>
                      </div>
                    </div>
                    <button type="button" class="btn btn-success btn-md pull-right addbtn" @click="onSubmitProfile" style="margin-top: -15px;">
                      ADD
                    </button>
                  </div>
                  <br />
                  <hr v-if="userSkills.length > 0">
                  <div class="lists" v-if="userSkills.length > 0">
                    <h3 class="tc">My Skillset</h3>
                    <table id="customers">
                      <tr>
                        <th>Skill</th>
                        <th>Self Rating</th>
                        <th>Years of Experience</th>
                        <th>Action</th>
                      </tr>
                      <tr v-for="(skill, index) in userSkills" :key="index">
                        <td>{{ skill.skill_desc }}</td>
                        <td>{{ skill.self_rating }}</td>
                        <td>
                          {{ skill.yearofexperience }}
                          {{ skill.monthofexperience }}
                        </td>
                        <td>
                          <a @click="tempSkill(skill, index)"
                            class="btn button-default"
                            id="skilldeletebtn"
                            style="background:none;color:red"
                            type="button"
                            data-toggle="modal" data-target="#deleteModal"
                            >Delete</a
                          >
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade " id="deleteModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog deleteskillmodal" role="document">
          <div class="modal-content " style="width:55%;">
            <div class="modal-header">
              <h3 class="modal-title skilltitle" id="exampleModalLabel" style="text-align:center">Delete Skill  <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button></h3>

            </div>
            <div class="modal-body">
              <p>Are you sure to delete the Required skills?</p>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                No
              </button>
              <button type="button" class="btn removeSkill" @click="removeSkill(tempId, tempIndex)">
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating'

import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import axios from 'axios'
import { BaseURL } from '../../../shared/classes'
// import { config } from 'vue/types/umd'
// import { logonew } from '../../shared/svg'
import $ from 'jquery'

export default {
  name: 'userprofile',
  components: { StarRating },
  data () {
    return {
      form: {
        skill_desc: '',
        self_rating: '1',
        yearofexperience: '',
        monthofexperience: '',
        firstName: localStorage.getItem('firstName')
      },
      user_id: '',
      signup: '',
      skills: [],
      skillData: [],
      matchName: '',
      userSkills: [],
      listSkills: [],
      skill_id: [],
      user_skill_id: '',
      addedSkills: '',
      submitted: false,
      skillexpired: false,
      tempId: ''
    }
  },
  computed: {
    filteredSkills () {
      return this.skills.filter(get =>
        get.name.toLowerCase().includes(this.form.skill_desc.toLowerCase())
      )
    }
  },
  created () {
    localStorage.getItem('firstName')
    localStorage.getItem('token')
    console.log(localStorage.getItem('token'))
    this.getaddedSkills()
    this.allSkillList()
    this.submitted = true
    // return this.$v.$touch()
  },
  mixins: [validationMixin],
  validations: {
    form: {
      skill_desc: {
        required
      },
      yearofexperience: {
        required
      },
      monthofexperience: {
        required
      }
    }
  },
  methods: {
    allSkillList () {
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios
        .get(BaseURL + '/skills/skills/ios', config)
        .then(response => {
          this.skills = response.data.all_skill
        })
        .catch(e => {})
    },
    nextPage () {
      if (this.signup === 'Success') {
        this.$awn.success('Skills Added Successfully')

        this.$router.push('/UploadPage')
      } else {
        this.submitted = true
        this.$v.$touch()

        // alert('Add the Required Skills and Proceed Next ')
      }
    },
    getSkill () {
      this.form.skill_desc = this.skillData[0].name
      console.log(this.form.skill_desc)
    },
    searchSkill () {
      this.skillData = this.skills
      if (this.form.skill_desc !== '' || this.form.skill_desc !== null) {
        for (let j = 0; j < this.skillData.length; j++) {
          this.matchName = this.skillData[j].name

          if (
            this.matchName
              .toLowerCase()
              .match(this.form.skill_desc.toLowerCase())
          ) {
            this.skills.push(this.skillData[j].name)
          }
        }
      }
    },
    getTime (event) {
      this.form.Experience = this.yearList.find(
        item => item.id === Number(event.target.value)
      )
    },
    getaddedSkills () {
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.get(BaseURL + '/profile/user/skill/' + localStorage.getItem('_id'), config).then(response => {
        this.addedSkills = response.data.userSkillInfo
        this.userSkills = response.data.userSkillInfo
      }).catch(e => {})
    },
    onSubmitProfile () {
      this.submitted = true
      this.skillexpired = false
      this.user_id = localStorage.getItem('_id')
      if (
        (this.form.skill_desc &&
          this.form.self_rating &&
          this.form.yearofexperience &&
          this.form.monthofexperience) === ''
      ) {
        this.$v.$touch()
      } else {
        const data = {
          skill_desc: this.form.skill_desc,
          self_rating: this.form.self_rating,
          yearofexperience: this.form.yearofexperience,
          monthofexperience: this.form.monthofexperience
        }
        console.log(data)
        const config = {
          headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
          }
        }
        axios.post(BaseURL + '/profile/add/user/skill/' + this.user_id, { formData: data }, config).then(response => {
          this.signup = response.data.message
          this.userSkills = response.data.userSkillInfo
          console.log(this.userSkills)
          console.log(this.signup)
          if (this.signup === 'Skill Already Exist') {
            this.skillexpired = true
            this.getaddedSkills()
          } else {
            this.listSkills.push(data)
            this.getaddedSkills()
          }
        })
      }
    },
    tempSkill (skill, index) {
      this.tempId = skill._id
      this.tempIndex = index
    },
    removeSkill (skill, index) {
      this.userSkills.splice(index, 1)
      $('#deleteModal').modal('hide')
      // this.userSkills.splice(index, 1)
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios
        .get(
          BaseURL + '/profile/user/skill/delete/' + this.user_id + '/' + skill,
          config
        )
        .then(response => {
          console.log(this.skillId)
        })
      this.$awn.success('Skill Deleted successfully')
    }
  }
}
</script>

<style scoped>
.removeSkill{
  text-align: center;
  background-color: #5bad2b;
  color: #fff;
}
.skilltitle{
  padding: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
.deleteskillmodal{
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}
#skilldeletebtn{
  width: 100%;
  height: 100%;
}
.nxtbtn {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  align-items: center;
}
.next {
  background: #5bad2b;
  color: white;
}
#customers {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  align-content: center;
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 70%;
  justify-content: center;
}

#customers td,
#customers th {
  border: 1px solid #ddd;
  padding: 8px;
}

#customers tr:nth-child(even) {
  background-color: #f2f2f2;
}

#customers tr:hover {
  background-color: #ddd;
}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
  background-color: #5bad2b;
  color: white;
}

.expyears {
  width: 25%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
.star {
  display: flex;
  justify-content: center;
}
.skills {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  align-content: center;
}
.rating {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.guidelines {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  align-content: flex-end;
}
.org {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.currentemp {
  width: 100%;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
}
.term {
  width: 100%;
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  align-content: center;
}
.designation {
  width: 30%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  align-content: flex-start;
}
.selectyear,
.selectmonth {
  display: inline-flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-evenly;
}
.experience {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.terms {
  width: 100%;
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.signupbtn {
  width: 100%;
  display: flex;
  justify-content: center;
}
.form-content .form-items {
  border: none !important;
  box-shadow: none !important;
}

/* .form-content .form-items {
    background-color: #ffffff !important;
} */
.newDesign {
  width: 44%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto !important;
}
.pwd_info {
  float: left;
  font-size: 12px;
  padding-bottom: 11px;
  color: red;
  margin-top: -10px;
}

.pwd_info_float_right {
  float: right;
  font-size: 12px;
  padding-bottom: 11px;
  color: #5bad2b;
  /* cursor: pointer; */
  margin-top: -10px;
}

.pading_____zero {
  margin-bottom: 2px !important;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}

.input-group.form-control.is-valid {
  background-image: none;
  padding-right: calc(1.5em + 0.75rem);
}
.input-group.form-control.is-invalid {
  background-image: none;
  padding-right: calc(1.5em + 0.75rem);
}

input.form-control.is-valid {
  background-image: none !important;
}

.form-holder {
  margin-left: 0px;
}

.login-policy-footer {
  width: 31%;
}

.progressbar {
  height: 5px !important;
  background: #e6e6e6;
}

ul {
  padding: 0px;
}

span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 0.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 7px;
}

.register____user__type {
  color: #000000;
  margin-bottom: 17px !important;
  cursor: pointer;
}

.progress_____round {
  border: 1px solid #5bad2b;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #5bad2b;
  font-weight: bold;
}

.progress_____round____hidden {
  border: 1px solid #bbb4b4;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #bbb4b4;
  font-weight: bold;
}

.form-content .form-items {
  max-width: 70%;
  padding: 25px;
  border: 1px solid #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.4);
}

svg {
  width: 100%;
}

.content-title {
  padding: 35px 0px 35px 105px;
}

.content-title-header {
  font-size: 22px;
  color: #000000;
}

.content-title-sub-header {
  color: #2f2f2f;
  font-size: 15px;
}

display-flex,
.signup-content,
.form-row,
.form-radio,
.select-icon,
.select-icon i {
  display: flex;
  display: -webkit-flex;
}

/* @extend list-type-ulli; */
list-type-ulli {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.file-loading {
  width: 50%;
}

img {
  max-width: 254px;
  height: auto;
}

figure {
  margin: 0;
}

.clear {
  clear: both;
}

.container {
  width: 100%;
  position: relative;
  margin: 0 auto;
  background: #f5f5f5;
}

.signup-img {
  width: 30%;
}

.signup-form {
  width: 70%;
}

.form-row {
  margin: 0 -15px;
}

.form-row .form-group {
  width: 50%;
  padding: 0 15px;
}

.form-group {
  margin-bottom: 15px !important;
  position: relative;
}
.form-items {
  margin-top: 2%;
}

label {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 2px;
  display: block;
}

.form-radio {
  margin-bottom: 18px;
}

.form-radio input {
  width: auto;
  display: inline-block;
}

.radio-label {
  padding-right: 72px;
}

.form-radio-item {
  position: relative;
  margin-right: 45px;
}

.form-radio-item label {
  font-weight: 400;
  font-size: 13px;
  padding-left: 25px;
  position: relative;
  z-index: 9;
  display: block;
  cursor: pointer;
}

.check {
  display: inline-block;
  position: absolute;
  border: 1px solid #ebebeb;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  -o-border-radius: 50%;
  -ms-border-radius: 50%;
  height: 13px;
  width: 13px;
  top: 4px;
  left: 0px;
  z-index: 5;
  transition: border 0.25s linear;
  -webkit-transition: border 0.25s linear;
}

.check:before {
  position: absolute;
  display: block;
  content: "";
  width: 9px;
  height: 9px;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  -o-border-radius: 50%;
  -ms-border-radius: 50%;
  top: 2px;
  left: 2px;
  margin: auto;
  transition: background 0.25s linear;
  -webkit-transition: background 0.25s linear;
}

input[type="radio"] {
  position: absolute;
  visibility: hidden;
}

input[type="radio"]:checked ~ .check {
  border: 1px solid #4dbd74;
}

input[type="radio"]:checked ~ .check::before {
  background: #4dbd74;
}

.form-select {
  position: relative;
}

select {
  appearance: none !important;
  -moz-appearance: none !important;
  -webkit-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  position: relative;
  background: 0 0;
  z-index: 10;
  cursor: pointer;
}

.select-icon {
  z-index: 999;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  justify-content: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  -o-justify-content: center;
  -ms-justify-content: center;
  align-items: center;
  -moz-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
  -ms-align-items: center;
}

.select-icon i {
  justify-content: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  -o-justify-content: center;
  -ms-justify-content: center;
  align-items: center;
  -moz-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
  -ms-align-items: center;
  width: 40px;
  height: 20px;
  font-size: 18px;
  color: #999;
}

.form-submit {
  text-align: right;
  padding-top: 27px;
}

@media screen and (max-width: 1024px) {
  /* .register-form {
    padding: 0px 40px 50px 0px;
  } */

  .signup-img,
  .signup-form {
    width: 100%;
  }

  .content-title {
    padding: 35px 0px 35px 125px;
  }

  .image-design {
    height: 254px;
  }

  .container {
    width: 100%;
    max-width: 100% !important;
  }
}

@media screen and (max-width: 992px) {
  .container {
    width: 100%;
    max-width: 100% !important;
  }

  .signup-img {
    width: 30%;
  }

  .signup-form {
    width: 70%;
  }

  .image-width {
    width: 100%;
    height: 100%;
  }

  .content-title {
    padding: 35px 0px 35px 0px;
  }
}

@media screen and (max-width: 800px) {
  .form-content .form-items {
    max-width: 100%;
    padding: 15px;
    border: none;
    box-shadow: none;
  }

  .signup-content {
    flex-direction: column;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    -ms-flex-direction: column;
  }

  .signup-img,
  .signup-form {
    width: 100%;
  }

  .content-title {
    padding: 35px 0px 35px 0px;
  }

  .image-design {
    height: 354px;
  }

  .content-title {
    padding: 35px 0px 35px 0px;
    text-align: center;
  }
}

@media screen and (max-width: 768px) {
  .signup-img,
  .signup-form {
    width: 100%;
  }

  .form-content .form-items {
    max-width: 100% !important;
    padding: 15px !important;
    border: none !important;
    box-shadow: none !important;
  }
}

@media screen and (max-width: 575px) {
  .form-row {
    flex-direction: column;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    -ms-flex-direction: column;
    margin: 0px;
  }

  .form-row .form-group {
    width: 100%;
    padding: 0px;
  }

  .radio-label {
    padding-right: 22px;
  }

  .form-radio-item {
    margin-right: 25px;
  }
}

@media screen and (max-width: 480px) {
  .form-radio {
    flex-direction: column;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    -ms-flex-direction: column;
  }
}

.image-design {
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}
.form-content {
  width: auto;
}
.form-row {
  margin: inherit;
}
.form-content h3 {
  margin-bottom: auto;
  margin-top: auto;
}
.mt-5 {
  margin-top: 35px;
}
.profile-image-center img {
  max-width: 100px;
  height: 100px;
}
.btn {
  width: 10%;
  height: 35px;
}
select.is-invalid {
  border: 1px solid red;
}
.vue-image-crop-upload
  .vicp-wrap
  .vicp-step2
  .vicp-crop
  .vicp-crop-left
  .vicp-range
  input[type="range"] {
  /* display: block; */
  padding-top: 10px !important;
}
.grey_color {
  color: #acacac !important;
}
.edit-icon {
  position: absolute;
  top: 65%;
  right: 0%;
  background-color: #efefef;
  padding: 7px;
  border-radius: 14px;
  color: black;
  border: 1px solid #ccc;
}
@media only screen and (min-device-width: 769px) and (max-device-width: 1024px) {
  .expyears {
  width: 35%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
}
  @media only screen and (min-device-width: 481px) and (max-device-width: 768px) {
    .expyears {
  width: 45%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
.skills {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  align-content: center;
  row-gap: 30px;
}
  }
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    .expyears {
  width: 65%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  column-gap: 10px;
}
.skills {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  align-content: center;
  row-gap: 30px;
}
.nxtbtn {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  align-items: flex-end;
}
.next {
  width: 18%;
  height: 30px;
}
.addbtn{
width: 18%;
margin-left: 6px;
}
.expyears.addbtn{
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;

}
  }
</style>
